module.exports = __webpack_public_path__ + "img/20210601.87338593.gif";